import { FC } from 'react';

import TableVacantRoutes from '../../../components/table/recruiting/tableVacantRoutesList';

import styles from './vacantRoutes.module.scss';

const VacantRoutes: FC = () => {
	return (
		<div className={styles.vacanctRoutes}>
			<TableVacantRoutes />
		</div>
	);
};

export default VacantRoutes;
